import axios from "axios";

import { UserCompanyLocation } from "../authService/userService";

export interface CompanyPersonnelsAndLocations {
  companyId: string;
  companyName: string;
  companyCode: number;
  alllocationlist: Location[];
  alllocationusers: Personnel[];
}

export interface Personnel {
  userId: string;
  fullName: string;
  locationName: string;
  status: boolean;
  isDeleted: boolean;
  userName: string;
  userPhoto: string;
  userRole: string;
}

export interface Location {
  locationId: string;
  locationName: string;
  activeUserCount: number;
  passiveUserCount: number;
  isDeleted: boolean;
}

export async function getCompanyLocationsAndUsers(companyId: string) {
  return await axios
    .get<CompanyPersonnelsAndLocations>(
      `/Companies/getlocationsandusersbycompanyid`,
      {
        params: { companyId },
      },
    )
    .then((res) => res.data);
}

export async function getLocationUsersByid(userID: string) {
  return await axios
    .get<UserCompanyLocation[]>(
      `/CompanyLocations/getcompanylocationsinfobyuserid`,
      {
        params: { userId: userID },
      },
    )
    .then((res) => res.data);
}
